import { render, staticRenderFns } from "./CapterraReviewsSection.vue?vue&type=template&id=1ee6df25&scoped=true"
import script from "./CapterraReviewsSection.vue?vue&type=script&lang=js"
export * from "./CapterraReviewsSection.vue?vue&type=script&lang=js"
import style0 from "./CapterraReviewsSection.vue?vue&type=style&index=0&id=1ee6df25&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee6df25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ee6df25')) {
      api.createRecord('1ee6df25', component.options)
    } else {
      api.reload('1ee6df25', component.options)
    }
    module.hot.accept("./CapterraReviewsSection.vue?vue&type=template&id=1ee6df25&scoped=true", function () {
      api.rerender('1ee6df25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Payment/Components/Sections/CapterraReviews/CapterraReviewsSection.vue"
export default component.exports